import { type Clip } from '@air/api/types';

import { type CanvasAssetPayload } from './canvasAssetDropTypes';

/** Converts a Clip to a CanvasAssetPayload for use by filterImageAssets / buildVideoNodes. */
export function clipToCanvasAssetPayload(clip: Clip): CanvasAssetPayload {
  return {
    assetId: clip.assetId,
    duration: clip.duration,
    ext: clip.ext,
    height: clip.height,
    id: clip.id,
    importedName: clip.importedName,
    media: { image: clip.assets?.image, original: clip.assets?.original },
    size: clip.size,
    status: clip.status,
    title: clip.title,
    type: clip.type,
    width: clip.width,
  };
}
